<!-- Translated: skip -->
<template>
  <div class="hello" v-if="SITE_CONFIG.env !== 'production'">
    <h1>{{ msg }}</h1>
    <h2>Bokning</h2>
    <ul>
      <li v-if="SITE_CONFIG.modules.accomodation"><router-link :to="{ name: 'accomodation list' }">Boenden</router-link></li>
      <li v-if="SITE_CONFIG.modules.accomodation"><router-link :to="{ name: 'addons' }">Tillval</router-link></li>
      <li v-if="SITE_CONFIG.modules.skiletting"><router-link :to="{ name: 'ski rental' }">Skidhyra</router-link></li>
      <li v-if="SITE_CONFIG.modules.skipass"><router-link :to="{ name: 'ski pass' }">Liftkort</router-link></li>
      <li v-if="SITE_CONFIG.modules.school"><router-link :to="{ path: 'skidskola/oversikt?type=group' }">Skidskola</router-link></li>
      <li v-if="SITE_CONFIG.modules.activities"><router-link :to="{ name: 'activities' }">Barnktiviteter</router-link></li>
    </ul>
    <br />
    <h2>Övriga sidor</h2>
    <ul>
      <li v-if="SITE_CONFIG.modules.accomodation"><router-link :to="{ name: 'my pages' }">Mina sidor</router-link></li>
      <li><router-link :to="{ name: 'shopping cart' }">Varukorg</router-link></li>
    </ul>
    <br />
    <h2>Admin</h2>
    <ul>
      <li><router-link :to="{ name: 'admin' }">Admin</router-link></li>
      <li v-if="SITE_CONFIG.modules.accomodation"><router-link :to="{ name: 'admin-accomodations' }">Boenden</router-link></li>
      <li><router-link :to="{ name: 'admin-settings' }">Inställningar</router-link></li>
      <li><router-link :to="{ name: 'admin-texts' }">Texter</router-link></li>
      <li><router-link :to="{ name: 'admin-stats-orders' }">Ordrar</router-link></li>
    </ul>

    <br />
    <h2>Inställningar</h2>

    <!--<div>
      <label>Backend</label>
      <select v-model="api_url" @change="updateSettings()">
        <option value="http://localhost:8000">Localhost</option>
        <option value="http://api.bokning17.branas.advanttest.se">Dev (branäs-server)</option>
        <option value="http://api.bokning17.kungsberget.advanttest.se">Dev (kungsberget-server)</option>
      </select>
    </div>-->
    <div>
      <label>Rensa varukorg och inställningar</label>
      <button @click="clean()">Rensa varukorg, inställningar och logga ut</button>
      <button @click="cleanCart()">Rensa varukorg</button>
    </div>

      <button @click="setLocal()">Sätt backend-URL</button>


      <h2>Features</h2>
      <table>
        <tr v-for="(isActive, feature) in SITE_CONFIG.features" :key="feature">
          <td style="padding-right: 5rem;">{{ feature }}</td>
          <td>{{ isActive ? '✅' : '❌' }}</td>
        </tr>
      </table>
      
      <h2>Settings</h2>
      <table>
        <tr v-for="(value, setting) in SITE_CONFIG.settings" :key="setting">
          <td style="padding-right: 5rem;">{{ setting }}</td>
          <td>{{ value }}</td>
        </tr>
      </table>

  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  data() {
    return {
      msg: 'Välkommen till Branäs bokning',
      api_url: '',
    };
  },
  mounted() {
    this.api_url = this.devSettings.api_url;

    if (this.SITE_CONFIG.env === 'production') {
      if (this.SITE_CONFIG.site === 'branas' || this.SITE_CONFIG.site === 'kungsberget') {
        this.$router.replace({ name: 'accomodation list' });
      } else {
        this.$router.replace({ name: 'ski rental' });
      }
    }
  },
  computed: {
    ...mapGetters([
      'devSettings',
    ]),
  },
  methods: {
    ...mapMutations([
      'saveDevSettings',
      'clearCart',
    ]),
    updateSettings() {
      this.saveDevSettings({
        api_url: this.api_url,
      });
    },
    clean() {
      localStorage.removeItem('branas-booking-default');
      window.location.reload();
    },
    cleanCart() {
      this.clearCart();
    },
    setLocal() {
      const defaultUrl = localStorage.getItem('branas/api_url') || 'https://branas-booking-backend.ddev.site';
      const url = window.prompt('Sätt URL (t.ex. https://branas-booking-backend.ddev.site)', defaultUrl);

      if (url) {
        localStorage.setItem('branas/api_url', url);
      }

      window.location.reload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// StartPage.vue?6d0df5b9